export enum CardAddFormFieldNamesEnum {
  StreetAddressOne = 'streetAddressOne',
  StreetAddressTwo = 'streetAddressTwo',
  City = 'city',
  CountryCode = 'countryCode',
  Email = 'email',
  State = 'state',
  FirstName = 'firstName',
  LastName = 'lastName',
  PostalCode = 'postalCode',
  IsPrimary = 'isPrimary',
  RoutingNumber = 'routingNumber',
  BankAccountNumber = 'bankAccountNumber',
  BankAccountType = 'bankAccountType',
  AgreementIndicator = 'agreementIndicator',
  Company = 'company'
}
